import React from 'react';
import { Dialog, DialogActions, DialogContent, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import type { ComparisonItem } from '../../../../../types/BaselineMeasurements';
import { ActionButton } from '../../../../../components';
import { TranslationKeys } from '../../../../../translations';
import { useIntl } from 'react-intl';

type ComparisonLogMissingDataDialogProps = {
  comparisonItem: ComparisonItem;
  onCloseDialog: () => void;
  onConfirmDialog: () => void;
  openDialog: boolean;
};

export const ComparisonLogMissingDataDialog = ({
  comparisonItem,
  onCloseDialog,
  onConfirmDialog,
  openDialog,
}: ComparisonLogMissingDataDialogProps) => {
  const intl = useIntl();
  const logItems = comparisonItem.insurerSource.logMissingData;
  return (
    <Dialog
      open={openDialog}
      title="Log missing data"
      fullWidth={true}
      maxWidth="lg"
      onClose={() => {
        onCloseDialog();
      }}
    >
      <DialogContent>
        <Table stickyHeader size="small" aria-label="log-missing-insurer-data" sx={{ padding: 0 }}>
          <TableHead>
            <TableRow>
              <TableCell key={'log-missing-field'} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                {intl.formatMessage({
                  id: 'baseline.comparison.item.comparison-result.without-insurer-source',
                })}
              </TableCell>
              <TableCell key={'log-missing-message'} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                {intl.formatMessage({
                  id: 'dashboard.subCategory.missingDetails',
                })}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logItems &&
              logItems.length > 0 &&
              logItems.map((logObject, index) =>
                Object.entries(logObject).map(([key, value], entryIndex) => (
                  <TableRow key={`${index}-${entryIndex}`}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                )),
              )}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <ActionButton messageId={TranslationKeys.close} onClick={() => onConfirmDialog()} />
      </DialogActions>
    </Dialog>
  );
};
